import React from 'react';
import PropTypes from 'prop-types';

import SelectRecordsPerPage from './SelectRecordsPerPage';
import Records from './Records';
import Pages from './Pages';

import './Pagination.sass';

function CustomPagination({ children, ...props }) {
  return (
    <div className="pagination">
      <div className="pagination-top">
        <SelectRecordsPerPage
          itemsPerPage={props.itemsPerPage}
          setItemsPerPage={props.setItemsPerPage}
        />
      </div>
      {children}
      <div className="pagination-bottom">
        <Pages {...props} />
        <Records {...props} />
      </div>
    </div>
  );
}

CustomPagination.propTypes = {
  pagination: PropTypes.bool.isRequired,
};

export default CustomPagination;
